<template>
  <div>
    <header-unauthenticated />

    <div class="container">
      <div class="login login--header-padding">
        <img src="@/assets/superliga/logo-3x.png" alt="" class="login__logo" v-if="$config.MODE == 'SUPERLIGA'">
        <img src="@/assets/logo.svg" alt="" class="login__logo" v-else>
        <div class="onboarding__title">
          <h3>{{$t('onboarding.title')}}</h3>
          <h4>{{$t('onboarding.subtitle')}}</h4>
        </div>
        <div class="form-group">
          <!-- Mobile datepicker -->
          <template v-if="isMobile">
            <input
            type="date"
            v-model.trim="$v.userModel.birthDate.$model"
            :class="{'has-error': $v.userModel.birthDate.$error && $v.userModel.birthDate.$invalid}"
            :id="$t('onboarding.form.birthDate')" class="form-control with-value" required />
            <label class="form-control-placeholder" :for="$t('onboarding.form.birthDate')">{{$t('onboarding.form.birthDate')}}</label>
          </template>
          <!-- Desktop datepicker -->
          <template v-else>
            <datepicker
            v-model.trim="$v.userModel.birthDate.$model"
            :class="{'has-error': $v.userModel.birthDate.$error && $v.userModel.birthDate.$invalid}"
            :id="$t('onboarding.form.birthDate')" class="form-control with-value" required
            :format="'dd/MM/yyyy'" :language="language[language.localLanguage]"></datepicker>
            <label class="form-control-placeholder" :for="$t('onboarding.form.birthDate')">{{$t('onboarding.form.birthDate')}}</label>
          </template>
        </div>
        <div class="form-group">
          <select 
          v-model.trim="$v.userModel.teamId.$model"
          :class="{'has-error': $v.userModel.teamId.$error && $v.userModel.team.$invalid}">
            <option disabled value="">{{$t('onboarding.form.team')}}</option>
            <option v-for="(team, idxTeam) in teams" :key="idxTeam" :value="team.id">{{team.name}}</option>
          </select>
        </div>
        <button class="button button--white" @click.prevent="loginOnboarding()" :disabled="$v.userModel.$invalid || submitted">
          <template v-if="!submitted">
            {{$t('onboarding.login')}}
          </template>
          <template v-else>
            {{$t('onboarding.loading')}} <div class="loading-points"><span>.</span><span>.</span><span>.</span></div>
          </template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import HeaderUnauthenticated from '@/components/Header/Unauthenticated.vue'
import Datepicker from 'vuejs-datepicker'
import { en, es } from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import persistentData from '@/plugins/persistentData'

export default {
  components: {
    HeaderUnauthenticated,
    Datepicker
  },
  data() {
    return {
      userModel: {
        birthDate: moment().format(),
        teamId: ''
      },
      submitted: false,
      isMobile: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(navigator.userAgent)),
      language: {
        localLanguage: persistentData.getData('language').toLowerCase(),
        en: en,
        es: es
      }
    }
  },
  computed: {
    ...mapState({
      teams: state => state.InfoModule.teams,
      profile: state => state.ProfileModule.profile,
    })
  },
  mounted() {
    if (this.teams.length == 0) this.$store.dispatch('getTeams')
  },
  methods: {
    async loginOnboarding() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.submitted = true
        let profileModel = this.profile
        profileModel.birthDate = this.userModel.birthDate
        profileModel.teamId = this.userModel.teamId

        const request = await this.$store.dispatch('profileUpdate', profileModel)
        if (request == undefined) this.submitted = false
        if (request.status == 200) this.$router.push('/home/games')
      }
    }
  },
  validations: {
    userModel: {
      birthDate: {
        required
      },
      teamId: {
        required
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/styles/_variables';
  .onboarding {

    &__title {
      text-align: center;
      padding-bottom: $margin-mega;
      max-width: 300px;

      h3 {
        margin: 0;
        color: $white;
        font-weight: 700;
        @include font-settings(kilo, base);
      }
    }
  }
</style>